var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExpadion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_658_3880)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#F7FFFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 20V14.9381H5.18259V17.9753L8.60941 14.5485L9.45153 15.3906L6.02471 18.8174H9.06188V20H4ZM14.9381 20V18.8174H17.9753L14.5581 15.4002L15.4002 14.5581L18.8174 17.9753V14.9381H20V20H14.9381ZM8.59976 9.44188L5.18259 6.02471V9.06188H4V4H9.06188V5.18259H6.02471L9.44188 8.59976L8.59976 9.44188ZM15.4002 9.44188L14.5581 8.59976L17.9753 5.18259H14.9381V4H20V9.06188H18.8174V6.02471L15.4002 9.44188Z",
    fill: "#05241B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_658_3880"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExpadion);
export default __webpack_public_path__ + "static/media/iconExpadion.e16703d8.svg";
export { ForwardRef as ReactComponent };